import React, { useState } from "react";
import AuditRow from "./AuditRow";

/** Table + expandable meta rows. Manages its own expand-one state. */
export default function AuditTable({ items, loading }) {
  const [expandedId, setExpandedId] = useState(null);

  return (
    <div className="border border-border overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="border-b border-border bg-secondary/50 text-left">
          <tr>
            <th className="p-3 overline">Waktu</th>
            <th className="p-3 overline">Kategori</th>
            <th className="p-3 overline">Aksi</th>
            <th className="p-3 overline">User</th>
            <th className="p-3 overline">Target</th>
            <th className="p-3 overline text-right">Detail</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={6} className="p-6 text-center overline">Memuat…</td>
            </tr>
          ) : items.length === 0 ? (
            <tr>
              <td colSpan={6} className="p-6 text-center text-muted-foreground">
                Tidak ada log yang cocok dengan filter.
              </td>
            </tr>
          ) : (
            items.map((it) => (
              <AuditRow
                key={it.id}
                item={it}
                expanded={expandedId === it.id}
                onToggle={() => setExpandedId(expandedId === it.id ? null : it.id)}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
